import { Directive, ElementRef, Input, AfterViewInit } from "@angular/core";

@Directive({
    selector: "[appEllipsis]",
})
export class EllipsisDirective implements AfterViewInit {
    @Input() maxWidth?: string;

    constructor(private el: ElementRef<HTMLElement>) {}

    ngAfterViewInit() {
        const style = this.el.nativeElement.style;
        style.whiteSpace = "nowrap";
        style.overflow = "hidden";
        style.textOverflow = "ellipsis";
        if (this.maxWidth) {
            style.maxWidth = this.maxWidth;
        }
    }
}
